import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder } from "@simonbackx/simple-encoding";
import { File } from "./File";
export class Resolution extends AutoEncoder {
}
__decorate([
    field({ decoder: File })
], Resolution.prototype, "file", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Resolution.prototype, "width", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Resolution.prototype, "height", void 0);
//# sourceMappingURL=Resolution.js.map